/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => {});
  document.addEventListener('theme:scroll:up', e => {});
  document.addEventListener('theme:scroll:down', e => {});

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => {});

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Guard against a vendor crash in <flickity-carousel>'s visibleSlides(): it falls back to
  // this.carouselInstance.size.width when this.carousel.clientWidth is 0, but Flickity never
  // measures a carousel that's display:none (inactive collection-tabs panels are hidden this
  // way on purpose, to keep their images from being eagerly fetched), so .size stays undefined
  // there and the read throws. Skip only that unmeasured case; every other state is delegated
  // to the original method unchanged. The real calculation still runs once a tab opens, since
  // tab switching already triggers carouselInstance.resize() -> Flickity's own resize event ->
  // visibleSlides() again, by then with a real width.
  customElements.whenDefined('flickity-carousel').then(function() {
    var CarouselElement = customElements.get('flickity-carousel');
    var originalVisibleSlides = CarouselElement.prototype.visibleSlides;

    CarouselElement.prototype.visibleSlides = function() {
      if (!this.carousel) {
        return originalVisibleSlides.call(this);
      }

      var flickitySize = this.carouselInstance && this.carouselInstance.size;
      var hasMeasuredFlickityWidth = flickitySize && typeof flickitySize.width === 'number';

      if (!this.carousel.clientWidth && !hasMeasuredFlickityWidth) {
        return;
      }

      return originalVisibleSlides.call(this);
    };

    // Guard against a second, independent vendor bug in the same class: this.carouselPrev /
    // this.carouselNext are queried immediately after `new Flickity(...)` in initCarousel(),
    // but Flickity doesn't insert its prev/next buttons synchronously, so that query always
    // finds nothing. The theme tries to re-query later on a 'theme:tab:change' listener, but
    // that listener is bound to the <flickity-carousel> element itself while the tabs switcher
    // dispatches the event on a different container, so it never bubbles down and never fires --
    // carouselPrev/carouselNext stay null for the carousel's entire lifetime. lockArrows() then
    // throws on every slide change ("Cannot set properties of null (setting 'disabled')").
    //
    // Fix: watch each carousel's this.carousel with a MutationObserver until the real
    // .flickity-button.previous/.next elements actually exist, then populate carouselPrev/
    // carouselNext from them and disconnect -- DOM-driven, not a guessed timeout. This script
    // loads well after theme.js has already constructed every carousel present at page load
    // (initCarousel already ran for all of them by the time this executes), so construction-time
    // methods can't be wrapped to catch those retroactively -- instead every existing
    // <flickity-carousel> is processed directly below, and connectedCallback is wrapped only to
    // cover any carousel added to the DOM later (e.g. dynamically loaded content). Guarded so
    // neither path can install a second observer for the same instance.
    var originalConnectedCallback = CarouselElement.prototype.connectedCallback;
    var originalLockArrows = CarouselElement.prototype.lockArrows;

    function populateArrowRefs(instance) {
      if (!instance.carousel) {
        return false;
      }
      var prev = instance.carousel.querySelector('.flickity-button.previous');
      var next = instance.carousel.querySelector('.flickity-button.next');
      if (prev && next) {
        instance.carouselPrev = prev;
        instance.carouselNext = next;
        return true;
      }
      return false;
    }

    function ensureArrowRefsWatched(instance) {
      if (instance.__arrowRefsObserver || populateArrowRefs(instance) || !instance.carousel) {
        return;
      }
      var observer = new MutationObserver(function() {
        if (populateArrowRefs(instance)) {
          observer.disconnect();
          instance.__arrowRefsObserver = null;
        }
      });
      instance.__arrowRefsObserver = observer;
      observer.observe(instance.carousel, { childList: true });
    }

    CarouselElement.prototype.connectedCallback = function() {
      var result = originalConnectedCallback.apply(this, arguments);
      ensureArrowRefsWatched(this);
      return result;
    };

    CarouselElement.prototype.lockArrows = function(index) {
      if (!this.carouselNext) {
        return;
      }
      return originalLockArrows.call(this, index);
    };

    Array.prototype.forEach.call(document.querySelectorAll('flickity-carousel'), ensureArrowRefsWatched);
  });

  // Judge.me's write-review-modal "Back" button ships from their own
  // extension bundle (injected client-side, not present in this theme's
  // source) with no href, which fails Lighthouse's crawlable-anchors SEO
  // audit. We only add a same-page href so it's a real anchor; Judge.me's
  // own click handler and modal-navigation behavior are left untouched.
  (function() {
    function patchJudgeMeBackButton() {
      var btn = document.querySelector('.jdgm-write-review-modal__btn--back');
      if (btn && !btn.hasAttribute('href')) {
        btn.setAttribute('href', window.location.pathname + window.location.search);
        return true;
      }
      return false;
    }
    if (!patchJudgeMeBackButton()) {
      var jdgmBackButtonObserver = new MutationObserver(function() {
        if (patchJudgeMeBackButton()) {
          jdgmBackButtonObserver.disconnect();
        }
      });
      jdgmBackButtonObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

/* ==========================================================================
   KND wishlist + back-in-stock (added 2026-09-11, cross-device sync 2026-09-11)
   --------------------------------------------------------------------------
   Vanilla, delegated, morph-safe. Pipeline re-renders the product section
   through the Section Rendering API on every variant change (Alpine.morph), so
   nothing here keeps state on DOM nodes: every control is re-hydrated from
   storage whenever the theme announces a section update or new nodes appear.

   WISHLIST
     Browser copy  localStorage  key  knd_wishlist_v1
                   { v: 1, updatedAt: ISO, customerId: <id|null>, syncedAt: ISO|null,
                     pending: { added: [productId], removed: [productId] },
                     items: [ { productId, handle, variantId|null, addedAt } ] }
     Account copy  customer metafield  knd.wishlist  (type json)
                   { v: 1, updatedAt: ISO, items: [ ...same item shape... ] }
                   — the cross-device source of truth for a signed-in customer.
                   Read two ways: Liquid emits it as <script id="knd-wishlist-server">
                   on every page (layout/theme.liquid), and KND.caa reads/writes it
                   live through Shopify's Customer Account API (KND.wishlist.sync).
     Sync rules    see KND.wishlist.sync below and HANDOFF.md §6m.
     Events        'knd:wishlist:change'  detail { items, count, productId, saved, item }
                   'knd:wishlist:synced'  detail { items, count, source }

   CUSTOMER ACCOUNT API (KND.caa)
     OAuth 2.0 / OpenID Connect public client with PKCE against the shop's
     discovery document (/.well-known/openid-configuration). The client id is a
     theme setting (public by definition; there is no secret). Tokens live in
     localStorage key knd_caa_v1 and are scoped to the signed-in customer id
     that Liquid reports. Silent re-authorisation uses prompt=none.

   BACK IN STOCK
     Provider     Klaviyo client API (public company id from the product block).
                  One POST per request, EMAIL channel only, no list subscription.
     Storage      localStorage  key  knd_restock_v1
                  { "<variantId>": { email, at } }   — used only to show the
                  "already on the list" state and avoid accidental duplicates.
     Events       'knd:restock:subscribed'  detail { productId, variantId, email }
   ========================================================================== */
(function () {
  'use strict';

  var KND = (window.KND = window.KND || {});
  var config = window.KNDConfig || {};
  var strings = config.strings || {};
  var rootUrl = (config.routes && config.routes.root) || '/';
  if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';
  var customerId = config.customerId ? String(config.customerId) : null;

  /* ---------- helpers ---------- */
  function readJSON(key) {
    try { var raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  function writeJSON(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch (e) { return false; }
  }
  function removeKey(key) { try { localStorage.removeItem(key); } catch (e) {} }
  function sessionGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function sessionSet(key, value) { try { sessionStorage.setItem(key, value); } catch (e) {} }
  function sessionRemove(key) { try { sessionStorage.removeItem(key); } catch (e) {} }
  function fill(template, map) {
    return String(template || '').replace(/%(\w+)%/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function toId(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? null : n;
  }
  function nowIso() { return new Date().toISOString(); }
  function warn() { if (window.console && console.warn) console.warn.apply(console, ['[KND]'].concat(Array.prototype.slice.call(arguments))); }

  var liveRegion = null;
  function announce(text) {
    if (!text) return;
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.className = 'visually-hidden';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.setAttribute('data-knd-live', '');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    window.setTimeout(function () { liveRegion.textContent = text; }, 50);
  }

  /* ======================================================================
     WISHLIST — store
     ====================================================================== */
  var WL_KEY = 'knd_wishlist_v1';
  var WL_MAX = 100;

  function normalizeItem(raw) {
    if (!raw) return null;
    var productId = toId(raw.productId);
    if (!productId || !raw.handle) return null;
    return {
      productId: productId,
      handle: String(raw.handle),
      variantId: toId(raw.variantId),
      addedAt: raw.addedAt || nowIso()
    };
  }
  function emptyState() {
    return { v: 1, updatedAt: null, customerId: null, syncedAt: null, pending: { added: [], removed: [] }, items: [] };
  }
  function uniqIds(list) {
    var seen = {}; var out = [];
    (list || []).forEach(function (id) { id = toId(id); if (id && !seen[id]) { seen[id] = true; out.push(id); } });
    return out;
  }
  function sortByAdded(items) {
    return items.slice().sort(function (a, b) { return (a.addedAt < b.addedAt) ? -1 : (a.addedAt > b.addedAt ? 1 : 0); });
  }
  /* Union of two item lists by productId. Earliest addedAt wins; a known
     variantId beats null. Order = addedAt ascending. Capped at WL_MAX. */
  function mergeItems(a, b) {
    var byId = {};
    (a || []).concat(b || []).forEach(function (raw) {
      var item = normalizeItem(raw);
      if (!item) return;
      var cur = byId[item.productId];
      if (!cur) { byId[item.productId] = item; return; }
      if (item.addedAt < cur.addedAt) cur.addedAt = item.addedAt;
      if (!cur.variantId && item.variantId) cur.variantId = item.variantId;
      if (item.handle && !cur.handle) cur.handle = item.handle;
    });
    var out = sortByAdded(Object.keys(byId).map(function (k) { return byId[k]; }));
    return out.length > WL_MAX ? out.slice(-WL_MAX) : out;
  }
  function parseServerPayload(raw) {
    var server = raw;
    if (typeof raw === 'string') { try { server = JSON.parse(raw); } catch (e) { server = null; } }
    if (!server || typeof server !== 'object' || !Array.isArray(server.items)) return null;
    return { v: 1, updatedAt: server.updatedAt || null, items: server.items.map(normalizeItem).filter(Boolean) };
  }

  var wishlist = {
    state: emptyState(),

    load: function () {
      var data = readJSON(WL_KEY);
      if (data && data.v === 1 && Array.isArray(data.items)) {
        this.state = {
          v: 1,
          updatedAt: data.updatedAt || null,
          customerId: data.customerId ? String(data.customerId) : null,
          syncedAt: data.syncedAt || null,
          pending: {
            added: uniqIds(data.pending && data.pending.added),
            removed: uniqIds(data.pending && data.pending.removed)
          },
          items: data.items.map(normalizeItem).filter(Boolean)
        };
      }
      this.reconcileIdentity();
      this.mergeServerSnapshot();
      return this.state;
    },

    /* Sign-out / account-switch handling. The account copy is the source of
       truth once a sync has happened, so a list that was synced to an account
       is cleared from this browser when that account signs out (shared
       devices). A never-synced list is kept — it is still only local data. */
    reconcileIdentity: function () {
      var previous = this.state.customerId;
      if (previous && previous !== customerId) {
        if (this.state.syncedAt) {
          this.state = emptyState();
        } else {
          this.state.customerId = null;
          this.state.syncedAt = null;
        }
        caa.clearTokens();
        this.save(false);
      }
      if (customerId && this.state.customerId !== customerId) {
        this.state.customerId = customerId;
        this.state.syncedAt = null;
        this.save(false);
      }
    },

    /* Liquid-rendered account copy (no API round-trip). Union on first contact;
       once synced, the live pull in sync.pull() is authoritative instead. */
    mergeServerSnapshot: function () {
      var el = document.getElementById('knd-wishlist-server');
      if (!el || !customerId) return;
      var server = parseServerPayload(el.textContent || 'null');
      if (!server) return;
      if (this.state.syncedAt) return; // live sync owns the list from here on
      var merged = mergeItems(this.state.items, server.items);
      if (merged.length !== this.state.items.length) { this.state.items = merged; this.save(false); }
    },

    save: function (touch) {
      if (touch !== false) this.state.updatedAt = nowIso();
      if (this.state.items.length > WL_MAX) this.state.items = this.state.items.slice(-WL_MAX);
      writeJSON(WL_KEY, this.state);
    },

    items: function () { return this.state.items.slice(); },
    count: function () { return this.state.items.length; },
    has: function (productId) {
      productId = toId(productId);
      return this.state.items.some(function (i) { return i.productId === productId; });
    },
    get: function (productId) {
      productId = toId(productId);
      for (var i = 0; i < this.state.items.length; i++) if (this.state.items[i].productId === productId) return this.state.items[i];
      return null;
    },

    add: function (raw) {
      var item = normalizeItem(raw);
      if (!item || this.has(item.productId)) return false;
      this.state.items.push(item);
      this.track('added', item.productId);
      this.save();
      this.emit(item.productId, true, item);
      return true;
    },
    remove: function (productId) {
      productId = toId(productId);
      var before = this.state.items.length;
      var removed = this.get(productId);
      this.state.items = this.state.items.filter(function (i) { return i.productId !== productId; });
      if (this.state.items.length === before) return false;
      this.track('removed', productId);
      this.save();
      this.emit(productId, false, removed);
      return true;
    },
    toggle: function (raw) {
      var productId = toId(raw.productId);
      return this.has(productId) ? (this.remove(productId), false) : (this.add(raw), true);
    },

    /* Op log of local changes not yet confirmed by the account copy. */
    track: function (op, productId) {
      var p = this.state.pending;
      var other = op === 'added' ? 'removed' : 'added';
      p[other] = p[other].filter(function (id) { return id !== productId; });
      if (p[op].indexOf(productId) === -1) p[op].push(productId);
    },
    clearPending: function () { this.state.pending = { added: [], removed: [] }; },

    /* Replace the local list from the account copy, re-applying anything still
       pending locally (added/removed while offline or before a token existed). */
    applyServer: function (server) {
      var self = this;
      var items = server.items.slice();
      var pendingRemoved = this.state.pending.removed;
      items = items.filter(function (i) { return pendingRemoved.indexOf(i.productId) === -1; });
      this.state.pending.added.forEach(function (id) {
        var local = self.get(id);
        if (local && !items.some(function (i) { return i.productId === id; })) items.push(local);
      });
      // mergeItems de-duplicates by productId (an account copy written by
      // another client may carry repeats), sorts by addedAt and caps at WL_MAX.
      this.state.items = mergeItems(items, []);
      this.save(false);
    },

    emit: function (productId, saved, item) {
      this.hydrate();
      this.sync.schedulePush();
      document.dispatchEvent(new CustomEvent('knd:wishlist:change', {
        bubbles: true,
        detail: { items: this.items(), count: this.count(), productId: productId, saved: saved, item: item || null }
      }));
    },
    emitSynced: function (source) {
      this.hydrate();
      document.dispatchEvent(new CustomEvent('knd:wishlist:synced', {
        bubbles: true,
        detail: { items: this.items(), count: this.count(), source: source }
      }));
    },

    /* ---- DOM ---- */
    hydrate: function (root) {
      var scope = root || document;
      var buttons = scope.querySelectorAll ? scope.querySelectorAll('[data-knd-wish]') : [];
      Array.prototype.forEach.call(buttons, this.hydrateButton, this);
      this.hydrateHeader();
    },
    hydrateButton: function (btn) {
      var saved = this.has(btn.getAttribute('data-product-id'));
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.classList.toggle('is-saved', saved);
      var label = btn.getAttribute(saved ? 'data-label-remove' : 'data-label-add');
      if (label) btn.setAttribute('aria-label', label);
      var text = btn.querySelector('[data-knd-wish-text]');
      if (text) text.textContent = text.getAttribute(saved ? 'data-text-remove' : 'data-text-add') || text.textContent;
    },
    hydrateHeader: function () {
      var count = this.count();
      Array.prototype.forEach.call(document.querySelectorAll('[data-knd-wish-link]'), function (link) {
        link.classList.toggle('has-items', count > 0);
        link.setAttribute('data-count', String(count));
        var sr = link.querySelector('[data-knd-wish-count-sr]');
        if (sr) sr.textContent = count > 0 ? ', ' + (count === 1 ? (strings.wishlistCountOne || '1 saved piece') : fill(strings.wishlistCountOther || '%count% saved pieces', { count: count })) : '';
      });
    },

    onClick: function (btn) {
      var item = {
        productId: btn.getAttribute('data-product-id'),
        handle: btn.getAttribute('data-handle'),
        variantId: btn.getAttribute('data-variant-id')
      };
      var saved = this.toggle(item);
      announce(saved ? strings.wishlistSaved : strings.wishlistRemoved);
      // First wishlist interaction while signed in without a token: fetch one
      // (silent when a session exists). The change is already saved locally.
      caa.ensureToken('interaction');
    }
  };

  /* ======================================================================
     WISHLIST — account sync (Customer Account API)
     ----------------------------------------------------------------------
     Rules (also in HANDOFF.md §6m):
       1. Guest: local only. Nothing leaves the browser.
       2. Sign-in, first sync on this browser (syncedAt == null):
          merged = union(local, account) → written to the account → local = merged.
       3. Signed in, later loads: pull account copy → local = account ⊕ pending
          local ops (adds/removes made while no token/offline) → push if pending.
       4. Every add/remove while signed in: local first, then a debounced push
          of the whole list (metafieldsSet). Failed pushes stay in `pending`
          and retry on the next change/load.
       5. Sign-out or account switch: tokens cleared; a list that was synced to
          the account is cleared from this browser (it lives on the account).
     ====================================================================== */
  var pushTimer = null;
  var pushInFlight = false;
  var pushAgain = false;

  wishlist.sync = {
    get provider() { return caa.enabled() ? 'customer-account-api' : 'none'; },

    payload: function () {
      return { v: 1, updatedAt: nowIso(), items: wishlist.items().map(function (i) {
        return { productId: i.productId, handle: i.handle, variantId: i.variantId, addedAt: i.addedAt };
      }) };
    },

    /* Pull the account copy and reconcile. Resolves true when local now mirrors
       the account (plus any pending ops that were then pushed). */
    pull: function () {
      if (!customerId || !caa.enabled()) return Promise.resolve(false);
      return caa.query('query KndWishlist { customer { id metafield(namespace: "knd", key: "wishlist") { value } } }')
        .then(function (data) {
          var c = data && data.customer;
          if (!c) throw new Error('no customer in response');
          if (c.id && toId(c.id.split('/').pop()) !== toId(customerId)) {
            caa.clearTokens();
            throw new Error('token belongs to a different customer');
          }
          var server = parseServerPayload(c.metafield && c.metafield.value) || { v: 1, updatedAt: null, items: [] };
          if (!wishlist.state.syncedAt) {
            // First contact on this browser: union, then write it back.
            wishlist.state.items = mergeItems(wishlist.state.items, server.items);
            wishlist.clearPending();
            wishlist.save(false);
            return wishlist.sync.push('first-sync').then(function () { return true; });
          }
          wishlist.applyServer(server);
          var hasPending = wishlist.state.pending.added.length || wishlist.state.pending.removed.length;
          wishlist.emitSynced('pull');
          return hasPending ? wishlist.sync.push('pending').then(function () { return true; }) : true;
        })
        .catch(function (e) { warn('wishlist pull failed:', e && e.message); return false; });
    },

    /* Write the whole local list to knd.wishlist. */
    push: function (reason) {
      if (!customerId || !caa.enabled()) return Promise.resolve({ ok: false, reason: 'no-write-path' });
      if (pushInFlight) { pushAgain = true; return Promise.resolve({ ok: false, reason: 'in-flight' }); }
      pushInFlight = true;
      var value = JSON.stringify(this.payload());
      var mutation = 'mutation KndWishlistSet($metafields: [MetafieldsSetInput!]!) { metafieldsSet(metafields: $metafields) { metafields { key updatedAt } userErrors { field message code } } }';
      var variables = { metafields: [{ ownerId: 'gid://shopify/Customer/' + customerId, namespace: 'knd', key: 'wishlist', type: 'json', value: value }] };
      return caa.query(mutation, variables).then(function (data) {
        var errs = data && data.metafieldsSet && data.metafieldsSet.userErrors;
        if (errs && errs.length) throw new Error(errs.map(function (e) { return e.message; }).join('; '));
        wishlist.clearPending();
        wishlist.state.syncedAt = nowIso();
        wishlist.save(false);
        wishlist.emitSynced('push:' + (reason || 'change'));
        return { ok: true };
      }).catch(function (e) {
        warn('wishlist push failed:', e && e.message);
        return { ok: false, reason: e && e.message };
      }).then(function (result) {
        pushInFlight = false;
        if (pushAgain) { pushAgain = false; return wishlist.sync.push('queued'); }
        return result;
      });
    },

    schedulePush: function () {
      if (!customerId || !caa.enabled() || !caa.hasToken()) return;
      window.clearTimeout(pushTimer);
      pushTimer = window.setTimeout(function () { wishlist.sync.push('change'); }, 700);
    }
  };

  /* ======================================================================
     CUSTOMER ACCOUNT API client (public, PKCE, prompt=none)
     ====================================================================== */
  var CAA_KEY = 'knd_caa_v1';
  var CAA_SESSION = 'knd_caa_attempt';
  var CAA_FLOW = 'knd_caa_flow';
  var caaCfg = config.caa || {};
  var discovery = null;

  function b64url(bytes) {
    var str = '';
    for (var i = 0; i < bytes.length; i++) str += String.fromCharCode(bytes[i]);
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function randomString(len) {
    var bytes = new Uint8Array(len);
    crypto.getRandomValues(bytes);
    return b64url(bytes);
  }
  function sha256(text) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) { return b64url(new Uint8Array(buf)); });
  }

  var caa = {
    enabled: function () {
      return !!(caaCfg.clientId && !config.designMode && window.crypto && crypto.subtle && window.isSecureContext);
    },
    tokens: function () {
      var t = readJSON(CAA_KEY);
      return (t && t.customerId === customerId && t.accessToken) ? t : null;
    },
    hasToken: function () { return !!this.tokens(); },
    clearTokens: function () { removeKey(CAA_KEY); },
    callbackUrl: function () { return location.origin + (caaCfg.callbackPath || '/pages/wishlist'); },
    navigate: function (url) { location.assign(url); },
    replace: function (url) { location.replace(url); },

    discover: function () {
      if (discovery) return Promise.resolve(discovery);
      return fetch('/.well-known/openid-configuration', { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('discovery ' + r.status); return r.json(); })
        .then(function (doc) {
          return fetch('/.well-known/customer-account-api', { credentials: 'omit' })
            .then(function (r) { return r.ok ? r.json() : {}; })
            .then(function (api) {
              discovery = {
                authorize: doc.authorization_endpoint,
                token: doc.token_endpoint,
                logout: doc.end_session_endpoint,
                graphql: api.graphql_api
              };
              return discovery;
            });
        });
    },

    /* Redirect to the authorization endpoint. `silent` = prompt=none (no UI;
       errors come back as ?error=login_required). One attempt per tab session. */
    authorize: function (silent, reason) {
      if (!this.enabled() || !customerId) return Promise.resolve(false);
      if (sessionGet(CAA_SESSION)) return Promise.resolve(false);
      sessionSet(CAA_SESSION, reason || '1');
      var verifier = randomString(48);
      var state = randomString(16);
      var nonce = randomString(16);
      var self = this;
      return Promise.all([this.discover(), sha256(verifier)]).then(function (res) {
        var d = res[0], challenge = res[1];
        sessionSet(CAA_FLOW, JSON.stringify({ verifier: verifier, state: state, nonce: nonce, returnTo: location.pathname + location.search + location.hash, at: Date.now() }));
        var params = new URLSearchParams({
          scope: 'openid email customer-account-api:full',
          client_id: caaCfg.clientId,
          response_type: 'code',
          redirect_uri: self.callbackUrl(),
          state: state,
          nonce: nonce,
          code_challenge: challenge,
          code_challenge_method: 'S256'
        });
        if (silent) params.set('prompt', 'none');
        self.navigate(d.authorize + '?' + params.toString());
        return true;
      }).catch(function (e) { warn('authorize failed:', e && e.message); return false; });
    },

    /* On the callback page: exchange ?code for tokens, then return to origin. */
    handleCallback: function () {
      var qs = new URLSearchParams(location.search);
      if (!qs.has('code') && !qs.has('error')) return Promise.resolve(false);
      var flowRaw = sessionGet(CAA_FLOW);
      sessionRemove(CAA_FLOW);
      var flow = null;
      try { flow = flowRaw ? JSON.parse(flowRaw) : null; } catch (e) { flow = null; }
      var clean = function () {
        var url = location.pathname + (location.hash || '');
        history.replaceState(null, '', url);
      };
      if (!flow || qs.get('state') !== flow.state) { clean(); return Promise.resolve(false); }
      if (qs.has('error')) {
        // e.g. login_required from prompt=none — stay local-only, no noise.
        warn('authorization returned', qs.get('error'));
        clean();
        return Promise.resolve(false);
      }
      var code = qs.get('code');
      var self = this;
      return this.discover().then(function (d) {
        var body = new URLSearchParams({
          grant_type: 'authorization_code',
          client_id: caaCfg.clientId,
          redirect_uri: self.callbackUrl(),
          code: code,
          code_verifier: flow.verifier
        });
        return fetch(d.token, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok || !json.access_token) throw new Error((json && (json.error_description || json.error)) || ('token ' + r.status));
          self.storeTokens(json);
          clean();
          sessionRemove(CAA_SESSION);
          var returnTo = flow.returnTo && flow.returnTo.indexOf('/') === 0 && flow.returnTo.split('?')[0] !== location.pathname ? flow.returnTo : null;
          return wishlist.sync.pull().then(function () {
            if (returnTo) { self.replace(returnTo); return 'redirecting'; }
            return true;
          });
        });
      }).catch(function (e) { warn('token exchange failed:', e && e.message); clean(); return false; });
    },

    storeTokens: function (json) {
      writeJSON(CAA_KEY, {
        customerId: customerId,
        accessToken: json.access_token,
        refreshToken: json.refresh_token || null,
        expiresAt: Date.now() + (Math.max(60, (json.expires_in || 3600) - 60) * 1000),
        obtainedAt: nowIso()
      });
    },

    refresh: function (t) {
      if (!t.refreshToken) return Promise.reject(new Error('no refresh token'));
      var self = this;
      return this.discover().then(function (d) {
        var body = new URLSearchParams({ grant_type: 'refresh_token', client_id: caaCfg.clientId, refresh_token: t.refreshToken });
        return fetch(d.token, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
      }).then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok || !json.access_token) throw new Error((json && json.error) || ('refresh ' + r.status));
          if (!json.refresh_token) json.refresh_token = t.refreshToken;
          self.storeTokens(json);
          return self.tokens();
        });
      });
    },

    /* A usable access token, refreshing when needed. Rejects when none. */
    accessToken: function () {
      var t = this.tokens();
      if (!t) return Promise.reject(new Error('not authorized'));
      if (Date.now() < t.expiresAt) return Promise.resolve(t.accessToken);
      var self = this;
      return this.refresh(t).then(function (nt) { return nt.accessToken; }).catch(function (e) {
        self.clearTokens();
        throw e;
      });
    },

    query: function (query, variables) {
      var self = this;
      return Promise.all([this.discover(), this.accessToken()]).then(function (res) {
        return fetch(res[0].graphql, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': res[1] },
          body: JSON.stringify({ query: query, variables: variables || {} })
        });
      }).then(function (r) {
        if (r.status === 401) { self.clearTokens(); throw new Error('unauthorized'); }
        return r.json();
      }).then(function (json) {
        if (json.errors && json.errors.length) throw new Error(json.errors.map(function (e) { return e.message; }).join('; '));
        return json.data;
      });
    },

    /* Obtain a token if we are signed in and have none. `reason` decides the
       trigger policy: 'load' only bounces when there is something to push or
       we are on the wishlist page and auto-sync is on; 'interaction' always. */
    ensureToken: function (reason) {
      if (!this.enabled() || !customerId || this.hasToken()) return false;
      var onWishlistPage = !!document.querySelector('[data-knd-wishlist-page]');
      var hasLocal = wishlist.count() > 0 || wishlist.state.pending.removed.length > 0;
      if (reason === 'load' && !(caaCfg.autoSync && (hasLocal || onWishlistPage))) return false;
      this.authorize(true, reason);
      return true;
    },

    /* Start-up: callback handling, silent token acquisition, then a pull. */
    boot: function () {
      if (!this.enabled()) return Promise.resolve('disabled');
      if (!customerId) { this.clearTokens(); return Promise.resolve('guest'); }
      var self = this;
      return this.handleCallback().then(function (handled) {
        if (handled) return 'callback';
        if (self.hasToken()) {
          // Pull on every wishlist-page view, whenever local ops are pending or
          // unsynced, and otherwise at most once per 5 minutes per tab session.
          var key = 'knd_caa_pulled_at';
          var last = parseInt(sessionGet(key) || '0', 10);
          var onWishlistPage = !!document.querySelector('[data-knd-wishlist-page]');
          var needs = !wishlist.state.syncedAt || wishlist.state.pending.added.length || wishlist.state.pending.removed.length || onWishlistPage || (Date.now() - last) > 5 * 60 * 1000;
          if (needs) { sessionSet(key, String(Date.now())); return wishlist.sync.pull().then(function () { return 'pulled'; }); }
          return 'token';
        }
        return self.ensureToken('load') ? 'authorizing' : 'no-token';
      });
    },

    debug: function () {
      var t = readJSON(CAA_KEY);
      return { enabled: this.enabled(), customerId: customerId, hasToken: !!t, expiresAt: t && new Date(t.expiresAt).toISOString(), refresh: !!(t && t.refreshToken), attempted: sessionGet(CAA_SESSION), syncedAt: wishlist.state.syncedAt, pending: wishlist.state.pending, discovery: discovery };
    }
  };

  /* ---------- wishlist page ---------- */
  var wishlistPage = {
    root: null,
    grid: null,
    empty: null,
    note: null,
    countEl: null,

    rendered: '',

    init: function (root) {
      this.root = root;
      this.grid = root.querySelector('[data-knd-wishlist-grid]');
      this.empty = root.querySelector('[data-knd-wishlist-empty]');
      this.note = root.querySelector('[data-knd-wishlist-note]');
      this.countEl = root.querySelector('[data-knd-wishlist-count]');
      this.render();
      document.addEventListener('knd:wishlist:change', this.onChange.bind(this));
      // A live pull from the account may change the list after first paint.
      document.addEventListener('knd:wishlist:synced', this.onSynced.bind(this));
    },

    signature: function () { return wishlist.items().map(function (i) { return i.productId; }).join(','); },

    setNote: function () {
      if (!this.note) return;
      var synced = !!(customerId && wishlist.state.syncedAt);
      var text = synced ? (this.note.getAttribute('data-note-synced') || this.note.getAttribute('data-note-guest')) : this.note.getAttribute('data-note-guest');
      if (text) this.note.textContent = text;
    },

    onSynced: function () {
      this.setNote();
      if (this.signature() === this.rendered) return;
      this.grid.innerHTML = '';
      this.grid.hidden = false;
      this.render();
    },

    setCount: function (n) {
      if (!this.countEl) return;
      this.countEl.textContent = n > 0 ? ' \u00b7 ' + n : '';
    },

    render: function () {
      var items = wishlist.items().reverse(); // newest first
      var self = this;
      this.rendered = this.signature();
      this.setNote();
      this.setCount(items.length);
      if (!items.length) { this.showEmpty(); return; }
      if (this.empty) this.empty.hidden = true;
      this.grid.hidden = false;
      if (this.note) this.note.hidden = false;
      this.grid.setAttribute('aria-busy', 'true');

      // Keep grid order stable regardless of fetch timing.
      var placeholders = items.map(function (item) {
        var wrap = document.createElement('div');
        wrap.className = 'knd-wishlist__item';
        wrap.setAttribute('data-knd-wishlist-item', '');
        wrap.setAttribute('data-product-id', String(item.productId));
        self.grid.appendChild(wrap);
        return wrap;
      });

      var pending = items.length;
      var queue = items.map(function (item, index) { return { item: item, index: index }; });
      var active = 0;
      var CONCURRENCY = 6;

      function next() {
        while (active < CONCURRENCY && queue.length) {
          var job = queue.shift();
          active += 1;
          load(job.item, job.index);
        }
      }

      function load(item, index) {
        self.fetchCard(item).then(function (result) {
          var wrap = placeholders[index];
          if (result.status === 'gone') {
            // Product no longer published — drop it quietly (only on a real 404).
            wrap.remove();
            wishlist.remove(item.productId);
            return;
          }
          if (!result.html) { wrap.remove(); return; }
          wrap.innerHTML = result.html;
          if (result.soldOut) self.appendNotify(wrap, item);
          wishlist.hydrate(wrap);
        }).catch(function () {
          placeholders[index].remove();
        }).then(function () {
          active -= 1;
          pending -= 1;
          if (pending === 0) {
            self.grid.style.minHeight = '';
            self.grid.setAttribute('aria-busy', 'false');
            self.setCount(wishlist.count());
            if (!self.grid.querySelector('[data-knd-wishlist-item]')) self.showEmpty();
          } else {
            next();
          }
        });
      }

      next();
    },

    /* Card markup comes from the theme's own section endpoint, so it is the
       exact product-grid-item used on collection pages. */
    fetchCard: function (item) {
      var url = rootUrl + 'products/' + encodeURIComponent(item.handle) + '?section_id=api-product-grid-item';
      var self = this;
      return fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (response.status === 404) return { status: 'gone' };
        if (!response.ok) throw new Error('wishlist card ' + response.status);
        return response.text().then(function (markup) {
          var buffer = document.createElement('div');
          buffer.innerHTML = markup;
          var content = buffer.querySelector('[data-api-content]');
          var card = content && content.querySelector('[data-item-id]');
          if (!card || card.getAttribute('data-item-id') === '') return { status: 'gone' };
          var productSoldOut = !!content.querySelector('.product-grid-item__content.sold-out');
          if (productSoldOut || !item.variantId) {
            return { status: 'ok', html: content.innerHTML, soldOut: productSoldOut };
          }
          return self.variantAvailable(item).then(function (available) {
            return { status: 'ok', html: content.innerHTML, soldOut: available === false };
          });
        });
      });
    },

    variantAvailable: function (item) {
      return fetch(rootUrl + 'products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product || !Array.isArray(product.variants)) return null;
          for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].id === item.variantId) return !!product.variants[i].available;
          }
          return null;
        })
        .catch(function () { return null; });
    },

    appendNotify: function (wrap, item) {
      var href = rootUrl + 'products/' + encodeURIComponent(item.handle) + (item.variantId ? '?variant=' + item.variantId : '') + '#knd-restock';
      var link = document.createElement('a');
      link.className = 'knd-wishlist__notify btn-text-thick-line';
      link.href = href;
      link.textContent = this.root.getAttribute('data-notify-label') || 'Notify me when it\'s back';
      wrap.appendChild(link);
    },

    showEmpty: function () {
      if (this.grid) { this.grid.style.minHeight = ''; this.grid.setAttribute('aria-busy', 'false'); this.grid.hidden = true; }
      if (this.empty) this.empty.hidden = false;
      if (this.note) this.note.hidden = true;
      this.setCount(0);
    },

    onChange: function (event) {
      if (event.detail.saved) return; // additions happen elsewhere; the page re-renders on next visit
      var el = this.grid.querySelector('[data-knd-wishlist-item][data-product-id="' + event.detail.productId + '"]');
      var self = this;
      if (el) {
        el.classList.add('is-removing');
        window.setTimeout(function () {
          el.remove();
          if (!self.grid.querySelector('[data-knd-wishlist-item]')) self.showEmpty();
        }, 260);
      }
      this.setCount(event.detail.count);
      if (event.detail.count === 0 && this.note) this.note.hidden = true;
    }
  };

  /* ======================================================================
     BACK IN STOCK
     ====================================================================== */
  var RS_KEY = 'knd_restock_v1';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var restock = {
    providers: {
      klaviyo: {
        subscribe: function (companyId, email, variantId) {
          var url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId);
          var body = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
              }
            }
          };
          return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' },
            body: JSON.stringify(body)
          }).then(function (response) {
            if (response.status === 202 || response.ok) return { ok: true };
            return response.json().catch(function () { return null; }).then(function (json) {
              var detail = json && json.errors && json.errors[0] && (json.errors[0].detail || json.errors[0].title);
              return { ok: false, status: response.status, detail: detail || ('HTTP ' + response.status) };
            });
          });
        }
      }
    },

    stored: function () { return readJSON(RS_KEY) || {}; },
    remember: function (variantId, email) {
      var map = this.stored();
      map[String(variantId)] = { email: email, at: new Date().toISOString() };
      writeJSON(RS_KEY, map);
    },
    forget: function (variantId) {
      var map = this.stored();
      delete map[String(variantId)];
      writeJSON(RS_KEY, map);
    },

    hydrate: function (root) {
      var scope = root || document;
      var blocks = scope.querySelectorAll ? scope.querySelectorAll('[data-knd-restock]') : [];
      Array.prototype.forEach.call(blocks, this.hydrateBlock, this);
    },
    hydrateBlock: function (block) {
      var variantId = block.getAttribute('data-variant-id');
      var record = this.stored()[String(variantId)];
      if (record && record.email) {
        this.showDone(block, fill(block.getAttribute('data-msg-already'), { email: record.email, variant: block.getAttribute('data-variant-title') }), false);
      } else {
        this.showForm(block);
      }
    },
    showDone: function (block, message, focus) {
      var form = block.querySelector('[data-knd-restock-form]');
      var done = block.querySelector('[data-knd-restock-done]');
      var text = block.querySelector('[data-knd-restock-done-text]');
      if (form) form.hidden = true;
      if (text) text.textContent = message;
      if (done) done.hidden = false;
      if (focus && text) { text.setAttribute('tabindex', '-1'); text.focus({ preventScroll: true }); }
    },
    showForm: function (block, focus) {
      var form = block.querySelector('[data-knd-restock-form]');
      var done = block.querySelector('[data-knd-restock-done]');
      if (done) done.hidden = true;
      if (form) {
        form.hidden = false;
        this.setMessage(block, '', false);
        if (focus) { var input = form.querySelector('input[type="email"]'); if (input) input.focus(); }
      }
    },
    setMessage: function (block, text, isError) {
      var msg = block.querySelector('[data-knd-restock-msg]');
      var input = block.querySelector('input[type="email"]');
      if (msg) { msg.textContent = text; msg.classList.toggle('is-error', !!isError && !!text); }
      if (input) {
        input.classList.toggle('is-invalid', !!isError && !!text);
        if (isError && text) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
      }
    },
    setBusy: function (block, busy) {
      var button = block.querySelector('[data-knd-restock-submit]');
      var label = block.querySelector('[data-knd-restock-submit-text]');
      var input = block.querySelector('input[type="email"]');
      if (button) { button.disabled = !!busy; button.setAttribute('aria-busy', busy ? 'true' : 'false'); }
      if (label) label.textContent = busy ? block.getAttribute('data-msg-sending') : (button && button.getAttribute('data-text-idle')) || label.textContent;
      if (input) input.readOnly = !!busy;
    },

    onSubmit: function (form) {
      var block = form.closest('[data-knd-restock]');
      if (!block || block.getAttribute('data-busy') === 'true') return;
      var input = form.querySelector('input[type="email"]');
      var email = (input && input.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(email)) {
        this.setMessage(block, block.getAttribute('data-msg-invalid'), true);
        if (input) input.focus();
        return;
      }
      var provider = this.providers[block.getAttribute('data-provider') || 'klaviyo'];
      var companyId = block.getAttribute('data-company-id');
      var variantId = block.getAttribute('data-variant-id');
      var productId = block.getAttribute('data-product-id');
      var variantTitle = block.getAttribute('data-variant-title');
      var self = this;

      this.setMessage(block, '', false);
      this.setBusy(block, true);
      block.setAttribute('data-busy', 'true');

      provider.subscribe(companyId, email, variantId).then(function (result) {
        if (!result.ok) throw new Error(result.detail || 'subscribe failed');
        self.remember(variantId, email);
        self.showDone(block, fill(block.getAttribute('data-msg-success'), { email: email, variant: variantTitle }), true);
        document.dispatchEvent(new CustomEvent('knd:restock:subscribed', {
          bubbles: true,
          detail: { productId: toId(productId), variantId: toId(variantId), email: email, provider: block.getAttribute('data-provider') || 'klaviyo' }
        }));
      }).catch(function (error) {
        if (window.console && console.warn) console.warn('[KND restock]', error && error.message);
        self.setMessage(block, block.getAttribute('data-msg-error'), true);
      }).then(function () {
        block.removeAttribute('data-busy');
        self.setBusy(block, false);
      });
    }
  };

  /* ======================================================================
     ANALYTICS — wishlist behaviour events (Klaviyo)
     ----------------------------------------------------------------------
     The customer metafield knd.wishlist is the persistent STATE; these are
     BEHAVIOUR events. The event contract is shared with the future KND app,
     which emits the same names/properties through Klaviyo's client Events
     API (POST /client/events/?company_id=<public key>):

       'Added to Wishlist' / 'Removed from Wishlist'
       { ProductID, ProductName, Handle, URL, ImageURL, Price, Currency,
         VariantID, VariantName, Vendor, WishlistCount, Source, $value }

     Web: sent through the Klaviyo onsite object (`klaviyo.push`) that the
     Shopify app embed already loads, so no key is needed here. Signed-in
     customers are identified by email (Klaviyo's standard logged-in pattern;
     identification never subscribes anyone). Product details come from the
     storefront's own /products/<handle>.js. Everything is best-effort and
     silent — wishlist behaviour never depends on it.
     ====================================================================== */
  var analytics = {
    cache: {},
    enabled: function () { return !!(window.klaviyo && typeof window.klaviyo.push === 'function') && !config.designMode; },
    identify: function () {
      if (!this.enabled() || !config.customerEmail) return;
      try { window.klaviyo.push(['identify', { $email: config.customerEmail }]); } catch (e) { /* silent */ }
    },
    product: function (handle) {
      var self = this;
      if (!handle) return Promise.resolve(null);
      if (this.cache[handle]) return this.cache[handle];
      this.cache[handle] = fetch(config.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      return this.cache[handle];
    },
    wishlistProps: function (item, product, count) {
      var variant = null;
      if (product && product.variants) {
        variant = product.variants.filter(function (v) { return item.variantId && v.id === item.variantId; })[0] || product.variants[0] || null;
      }
      var price = variant ? variant.price / 100 : (product ? product.price / 100 : null);
      var origin = location.origin;
      return {
        ProductID: item.productId,
        ProductName: product ? product.title : item.handle,
        Handle: item.handle,
        URL: origin + config.routes.root.replace(/\/$/, '') + '/products/' + item.handle + (item.variantId ? '?variant=' + item.variantId : ''),
        ImageURL: product && product.featured_image ? (product.featured_image.indexOf('//') === 0 ? 'https:' + product.featured_image : product.featured_image) : null,
        Price: price,
        Currency: config.shopCurrency || (window.Shopify && Shopify.currency && Shopify.currency.active) || null,
        VariantID: item.variantId || (variant ? variant.id : null),
        VariantName: variant ? variant.title : null,
        Vendor: 'KND',
        WishlistCount: count,
        Source: 'web',
        $value: price
      };
    },
    onWishlistChange: function (event) {
      if (!this.enabled()) return;
      var d = event.detail || {};
      var item = d.item || (d.productId ? { productId: d.productId, handle: null, variantId: null } : null);
      if (!item || !item.handle) return;
      var self = this;
      this.product(item.handle).then(function (product) {
        var props = self.wishlistProps(item, product, d.count);
        try { window.klaviyo.push(['track', d.saved ? 'Added to Wishlist' : 'Removed from Wishlist', props]); } catch (e) { /* silent */ }
      });
    },
    init: function () {
      if (!this.enabled()) return;
      this.identify();
      document.addEventListener('knd:wishlist:change', this.onWishlistChange.bind(this));
    }
  };

  /* ======================================================================
     wiring
     ====================================================================== */
  KND.wishlist = wishlist;
  KND.restock = restock;
  KND.caa = caa;
  KND.analytics = analytics;

  function hydrateAll(root) {
    wishlist.hydrate(root);
    restock.hydrate(root);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-knd-wish]');
    if (btn) { event.preventDefault(); event.stopPropagation(); wishlist.onClick(btn); return; }
    var reset = event.target.closest && event.target.closest('[data-knd-restock-reset]');
    if (reset) {
      var block = reset.closest('[data-knd-restock]');
      if (block) { restock.forget(block.getAttribute('data-variant-id')); restock.showForm(block, true); }
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('[data-knd-restock-form]');
    if (!form) return;
    event.preventDefault();
    restock.onSubmit(form);
  });

  // Re-hydrate after the theme morphs a section (variant change re-renders the
  // whole product section, including the restock block and the Save button).
  window.addEventListener('theme:section:update', function () { hydrateAll(document); });
  document.addEventListener('theme:recent-products:added', function (e) { hydrateAll(e.target || document); });
  document.addEventListener('theme:related-products:added', function (e) { hydrateAll(e.target || document); });

  // Cards injected by pagination/filters/quick views/drawers.
  var pendingNodes = [];
  var scheduled = false;
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches('[data-knd-wish],[data-knd-restock]') || node.querySelector('[data-knd-wish],[data-knd-restock]'))) {
          pendingNodes.push(node);
        }
      }
    }
    if (pendingNodes.length && !scheduled) {
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        var nodes = pendingNodes.splice(0);
        nodes.forEach(function (n) { if (n.isConnected) hydrateAll(n); });
      });
    }
  });

  function start() {
    wishlist.load();
    analytics.init();
    hydrateAll(document);
    var page = document.querySelector('[data-knd-wishlist-page]');
    // Boot the account sync first so a callback exchange/pull lands before the
    // wishlist page draws its cards; the page re-renders on 'knd:wishlist:synced'.
    caa.boot().then(function (outcome) {
      if (outcome === 'redirecting') return;
      if (page) wishlistPage.init(page, outcome);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ===========================================================================
   Accessibility — Flickity product gallery, aria-hidden focus trap
   ---------------------------------------------------------------------------
   Flickity sets aria-hidden="true" on off-screen .product__media cells but
   leaves their zoom/info buttons in the tab order. axe flags this as
   `aria-hidden-focus` ("[aria-hidden=true] elements contain focusable
   descendents") and it caps mobile PDP Lighthouse Accessibility at 96.
   Desktop is unaffected because the gallery renders as a static grid there.

   Mirror each cell's hidden state onto its focusable controls: tabindex="-1"
   while hidden, original value restored when the slide becomes selected. The
   original tabindex is stashed so we never invent one. Driven by a
   MutationObserver rather than Flickity's API, because the instance is not
   exposed globally and the gallery re-initialises on breakpoint changes.
   =========================================================================== */
(function () {
  var CELL = '.product__media.flickity-cell';
  var FOCUSABLE = 'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var STASH = 'data-knd-prev-tabindex';

  function syncCell(cell) {
    if (!cell || !cell.querySelectorAll) return;
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    var nodes = cell.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (hidden) {
        if (!el.hasAttribute(STASH)) el.setAttribute(STASH, el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute(STASH)) {
        var prev = el.getAttribute(STASH);
        if (prev) el.setAttribute('tabindex', prev); else el.removeAttribute('tabindex');
        el.removeAttribute(STASH);
      }
    }
  }

  function syncAll() {
    var cells = document.querySelectorAll(CELL);
    for (var i = 0; i < cells.length; i++) syncCell(cells[i]);
  }

  function start() {
    if (!document.querySelector('.product__grid')) return;
    syncAll();
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes' && m.target.matches && m.target.matches(CELL)) syncCell(m.target);
        else if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) syncAll();
      }
    });
    var grids = document.querySelectorAll('.product__grid');
    for (var g = 0; g < grids.length; g++) {
      mo.observe(grids[g], { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
    }
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(syncAll, 250); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
